import { render, staticRenderFns } from "./AssessmentSolutionCostsPanel.vue?vue&type=template&id=8863be6a&scoped=true&"
import script from "./AssessmentSolutionCostsPanel.vue?vue&type=script&lang=js&"
export * from "./AssessmentSolutionCostsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentSolutionCostsPanel.vue?vue&type=style&index=0&id=8863be6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8863be6a",
  null
  
)

export default component.exports